var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 11,
    viewBox: "0 0 17 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7853 0.719651L16.2803 5.2144C16.5464 5.4805 16.5708 5.8968 16.3534 6.1904L16.2809 6.2745L11.7858 10.7794C11.4933 11.0726 11.0184 11.0731 10.7252 10.7805C10.4586 10.5145 10.434 10.0979 10.6515 9.8041L10.724 9.7199L13.9409 6.497L1.2451 6.4977C0.865398 6.4977 0.551598 6.2155 0.501898 5.8494L0.495098 5.7477C0.495098 5.368 0.777197 5.0542 1.1433 5.0045L1.2451 4.9977L13.9429 4.997L10.7246 1.78035C10.4584 1.51409 10.4341 1.09743 10.652 0.803811L10.7246 0.719691C10.9909 0.453411 11.4075 0.429191 11.7011 0.647041L11.7853 0.719651Z",
    fill: "#002546"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d426c521ef1845e1a1e437214d28607e.svg";
export { ForwardRef as ReactComponent };